export default () => ({
  clientId: '',
  invoices: [null]
});
